export class LegalHoliday
{
    public id:number|null;
    public country_id:number;
    public holiday_name:string;
    public holiday_date:Date|null;

    constructor(data:LegalHolidayData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.country_id = -1;
            this.holiday_name = "";
            this.holiday_date = null;
        }
        else
        {
            this.id = data.id;
            this.country_id = data.country_id;
            this.holiday_name = data.holiday_name;
            this.holiday_date = data.holiday_date;
        }
    }
    public resetToDefaults():void {
        this.id = null;
        this.country_id = -1;
        this.holiday_name = '';
        this.holiday_date = null;
    }
}

export type LegalHolidayData = {
    id:number|null;
    country_id:number;
    holiday_name:string;
    holiday_date:Date|null;
}
